import type * as THREE from 'three';
import type { RigSize } from '../config/character-roster';
import { createCharacterPackCache } from './character-pack-cache';

/**
 * Loads and caches frontend/public/assets/adventurers/ — a separate cache
 * from render/gltf-cache.ts (dungeon-pack specific: different base path,
 * and characters/animations ship as .glb while dungeon-pack ships .gltf).
 * Delegates to character-pack-cache.ts's generic loader (extracted once
 * frontend/public/assets/skeletons/ needed the identical shape — see that
 * module's comment); this file's own public API is unchanged.
 */

const cache = createCharacterPackCache('/assets/adventurers');

export function loadCharacterModel(modelName: string): Promise<THREE.Group> {
  return cache.loadCharacterModel(modelName);
}

export function loadEquipmentModel(modelName: string): Promise<THREE.Group> {
  return cache.loadEquipmentModel(modelName);
}

/** design/gdd/equipment.md's worn-gear amendment — a generated piece from `tools/make-armour.py`. */
export function loadGearModel(defId: string): Promise<THREE.Group> {
  return cache.loadGearModel(defId);
}

export function loadRigAnimations(rig: RigSize): Promise<THREE.AnimationClip[]> {
  return cache.loadRigAnimations(rig);
}

export function loadSkinTexture(skinAssetKey: string): Promise<THREE.Texture> {
  return cache.loadSkinTexture(skinAssetKey);
}

export function loadAdditiveClip(
  rig: string, sourceClipName: string, referenceClipName?: string,
): Promise<THREE.AnimationClip> {
  return cache.loadAdditiveClip(rig, sourceClipName, referenceClipName);
}

export function loadEmoteClips(rig: RigSize): Promise<THREE.AnimationClip[]> {
  return cache.loadEmoteClips(rig);
}
